var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !!_vm.summaryDetails
      ? _c("div", { staticClass: "panel-summary-group row" }, [
          _c(
            "div",
            {
              staticClass:
                "panel-summary panel-summary-warning col-md-12 col-lg-4"
            },
            [
              _c("div", { staticClass: "panel-header font-white" }, [
                _c("h3", { staticClass: "title" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.AttendanceSummary.absencesLabel")
                      ) +
                      "\n\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _c("strong", { staticClass: "total" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.summaryDetails.ABSENCES.TOTAL_DAYS) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.AttendanceSummary.daysAllLowercase"
                          )
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body panel-body-table" }, [
                _c(
                  "table",
                  {
                    staticClass: "table table-striped attendance-summary-table"
                  },
                  [
                    _c("thead", { staticClass: "sr-only" }, [
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("th", { attrs: { scope: "col" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AttendanceSummary.daysAllCaps"
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "stat-row-th",
                                attrs: { scope: "row" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.excusedWithColon"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "stat-col" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.summaryDetails.ABSENCES.EXCUSED) +
                                  "\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.daysAllLowercase"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "stat-row-th",
                                attrs: { scope: "row" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.unexcusedWithColon"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "stat-col" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.summaryDetails.ABSENCES.UNEXCUSED
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.daysAllLowercase"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "stat-row-th",
                                attrs: { scope: "row" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.unlawfulWithColon"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "stat-col" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.summaryDetails.ABSENCES.UNLAWFUL) +
                                  "\n\t\t\t\t\t\t\t\t\t"
                              ),
                              _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AttendanceSummary.daysAllLowercase"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ])
                        ]
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "panel-summary panel-summary-gold col-md-12 col-lg-8"
            },
            [
              _c("div", { staticClass: "panel-header font-white" }, [
                _c("h3", { staticClass: "title" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.AttendanceSummary.tardySlashEarlyDismissal"
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                !!_vm.summaryDetails.TARDY.TOTAL_EARLY_DISMISSAL
                  ? _c("p", { staticClass: "text-center" }, [
                      _c("strong", { staticClass: "total" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.summaryDetails.TARDY.TOTAL_EARLY_DISMISSAL
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.AttendanceSummary.earlyAllCaps"
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _c("strong", { staticClass: "total" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.summaryDetails.TARDY.TOTAL_TARDY) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.AttendanceSummary.tardyAllCaps")
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _c("strong", { staticClass: "total" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.summaryDetails.TARDY.TOTAL_MINUTES) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t("MAIN_CONTENT.AttendanceSummary.minAllCaps")
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body panel-body-table" }, [
                _c(
                  "table",
                  {
                    staticClass: "table table-striped attendance-summary-table"
                  },
                  [
                    _c("thead", { staticClass: "sr-only" }, [
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("th", { attrs: { scope: "col" } }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AttendanceSummary.daysAllLowercase"
                                )
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        [
                          !!_vm.summaryDetails.TARDY.EXCUSED.EARLY_DISMISSAL ||
                          !!_vm.summaryDetails.TARDY.EXCUSED.TARDY ||
                          !!_vm.summaryDetails.TARDY.EXCUSED.MINUTES
                            ? _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "stat-row-th",
                                    attrs: { scope: "row" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.AttendanceSummary.excusedWithColon"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "stat-col" },
                                  [
                                    !!_vm.summaryDetails.TARDY.EXCUSED
                                      .EARLY_DISMISSAL
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY.EXCUSED
                                                  .EARLY_DISMISSAL
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.earlyAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.EXCUSED.TARDY
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY.EXCUSED
                                                  .TARDY
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.tardyAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.EXCUSED.MINUTES
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY.EXCUSED
                                                  .MINUTES
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.minAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !!_vm.summaryDetails.TARDY.UNEXCUSED
                            .EARLY_DISMISSAL ||
                          !!_vm.summaryDetails.TARDY.UNEXCUSED.TARDY ||
                          !!_vm.summaryDetails.TARDY.UNEXCUSED.UNLAWFUL
                            ? _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "stat-row-th",
                                    attrs: { scope: "row" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.AttendanceSummary.unexcusedWithColon"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "stat-col" },
                                  [
                                    !!_vm.summaryDetails.TARDY.UNEXCUSED
                                      .EARLY_DISMISSAL
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNEXCUSED.EARLY_DISMISSAL
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.earlyAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.UNEXCUSED.TARDY
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNEXCUSED.TARDY
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.tardyAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.UNEXCUSED.MINUTES
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNEXCUSED.MINUTES
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.minAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !!_vm.summaryDetails.TARDY.UNLAWFUL.EARLY_DISMISSAL ||
                          !!_vm.summaryDetails.TARDY.UNLAWFUL.TARDY ||
                          !!_vm.summaryDetails.TARDY.UNLAWFUL.UNLAWFUL
                            ? _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "stat-row-th",
                                    attrs: { scope: "row" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.AttendanceSummary.unlawfulWithColon"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "stat-col" },
                                  [
                                    !!_vm.summaryDetails.TARDY.UNLAWFUL
                                      .EARLY_DISMISSAL
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNLAWFUL.EARLY_DISMISSAL
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "stat-col" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.AttendanceSummary.earlyAllLowercase"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.UNLAWFUL.TARDY
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNLAWFUL.TARDY
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.AttendanceSummary.tardyAllLowercase"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]),
                                          _vm._v(" / \n\t\t\t\t\t\t\t\t\t")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !!_vm.summaryDetails.TARDY.UNLAWFUL.MINUTES
                                      ? [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.summaryDetails.TARDY
                                                  .UNLAWFUL.MINUTES
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "stat-col" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.AttendanceSummary.minAllLowercase"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ]
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }